import sdkInstanceProvider from "../sdk/sdkInstanceProvider";
import { noticeError } from "@src/helpers/monitoring";

export async function getIsAuthenticated() {
  try {
    const { customer } = await sdkInstanceProvider("identity");
    const isAuthenticated = await customer.isAuthenticated();

    return isAuthenticated;
  } catch (error) {
    noticeError(error);
    return false;
  }
}
